var _defs, _g, _path, _path2, _path3, _g2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJumpSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 25.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20,19.38h1c0-.18-.01-.37-.03-.55l-1.01.18c0,.12.04.24.04.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.95,16.47c.14-.2.3-.39.47-.57l-.65-.77c-.26.26-.49.54-.7.84l.88.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.42,16.83l-.87.5c.1.22.17.46.24.7l1-.18c-.09-.36-.22-.7-.37-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.04,19.01l-1.01-.18c-.02.18-.03.36-.03.55h1c0-.13.03-.24.04-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.05,16.47l.88-.51c-.21-.3-.44-.58-.7-.84l-.65.77c.17.18.33.37.47.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.21,18.03c.07-.24.14-.47.24-.7l-.87-.5c-.15.33-.28.67-.37,1.02l1,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.17,14.89c.22.11.44.22.65.36l.64-.77c-.3-.21-.61-.39-.94-.54l-.35.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.19,15.25c.2-.14.42-.25.65-.36l-.35-.95c-.33.15-.65.34-.94.54l.64.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.77,14.55c.24-.06.48-.09.73-.12v-1.03c-.37.03-.73.1-1.07.19l.35.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.5,14.43c.25.02.49.06.73.12l.35-.95c-.35-.09-.7-.16-1.07-.19v1.03Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.68,17.31L17.54,0l-.98.18,3.14,17.31c-.54.31-.85.92-.73,1.56.15.82.93,1.36,1.74,1.21s1.36-.93,1.21-1.74c-.12-.64-.63-1.11-1.24-1.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.49,17.17l-2.53-2.53-.71.71,2.53,2.53c.17-.29.41-.53.71-.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.22,17.88l2.53-2.53-.71-.71-2.53,2.53c.29.17.53.41.71.71Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.57,18.39h-3.57v1h3.57c-.08-.33-.08-.67,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.43,18.39c.08.33.08.67,0,1h3.57v-1h-3.57Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.21,16.41l-.95.95c3.32.68,5.49,1.76,5.49,2.99,0,2.07-6.16,3.75-13.75,3.75s-13.75-1.68-13.75-3.75c0-1.26,2.27-2.36,5.75-3.04v-1.18c-4.2.89-7,2.44-7,4.22,0,2.76,6.72,5,15,5s15-2.24,15-5c0-1.6-2.27-3.02-5.79-3.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpSafe);
export default __webpack_public_path__ + "static/media/jump_safe.aa0a603b16f35a3ce006db7135c27ce2.svg";
export { ForwardRef as ReactComponent };